export default __webpack_public_path__ + "static/media/moon-painting.c51968d4.png";